import { render, staticRenderFns } from "./SignupView.vue?vue&type=template&id=27d85f0c&"
import script from "./SignupView.vue?vue&type=script&lang=ts&"
export * from "./SignupView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports